const OverviewTab = ({ lesson }) => {
  if (!lesson) {
    return (
      <div className="overview-tab">
        <div className="overview-content">
          <p className="text-muted">Select a lesson to view its overview.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="overview-tab">
      <div className="overview-content">
        <h6 className="mb-3">Lesson Overview</h6>
        <div className="lesson-details">
          <div className="row">
            <div className="col-md-6">
              <p><strong>Lesson Type:</strong> {lesson.content_type.charAt(0).toUpperCase() + lesson.content_type.slice(1)}</p>
            </div>
            <div className="col-md-6">
              <p><strong>Status:</strong> 
                <span className={`badge ms-2 ${lesson.completed ? 'bg-success' : 'bg-warning'}`}>
                  {lesson.completed ? 'Completed' : 'In Progress'}
                </span>
              </p>
            </div>
          </div>
        </div>
        
        <div className="lesson-description mt-4">
          <p>
            This lesson is part of your course curriculum. Make sure to complete all the content 
            and check the exercise files if available.
          </p>
          {lesson.content_type === 'doc' && (
            <p>
              <i className="fas fa-info-circle text-info me-2"></i>
              Access the Exercise Files tab to download and view the document materials.
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default OverviewTab